import React, { FC, useContext } from 'react';
import { Popover, Box, Text, Theme } from '@bechtel/gds';
import { ThemeContext } from 'styled-components';
import { CrewChangeRequestPopoverProps } from './types';
import { Trans } from '@lingui/macro';

export const CrewChangeRequestPopover: FC<CrewChangeRequestPopoverProps> = ({ refElement, showPopper }) => {
  const { colors } = useContext<Theme>(ThemeContext);
  const popoverBgColor = String(colors.grey[900]);
  return (
    <Popover
      triggerComponentRef={refElement}
      placement="bottom"
      showPopper={showPopper}
      customStyle={{ zIndex: 1, backgroundColor: popoverBgColor }}
    >
      <Box p={{ sm: '300' }}>
        <Text size="300" color="white">
          <Trans>Request in Progress</Trans>
        </Text>
      </Box>
    </Popover>
  );
};
